import './style.scss';

import React, { useCallback, useContext } from 'react';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { toggleTelemetry } from 'app/redux/xrayGeneratorConfiguration/actions';
import { selectTelemetry } from 'app/redux/xrayGeneratorConfiguration/reducer';
import XRayGeneratorManagerContext from 'app/providers/XRayGeneratorManagerProvider/context';
import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';
import { Toggle, ToggleProps } from 'rsuite';

const XRayGeneratorConfiguration = React.memo(() => {
  const xRayGeneratorManager = useContext(XRayGeneratorManagerContext);
  if (!xRayGeneratorManager) return null;

  const dispatch = useDispatch();
  const intl = useIntl();
  const requestValidation = useContext(TechnicianPasswordValidationContext);
  const isTelemetry: boolean = useSelector(selectTelemetry) ?? false;

  const onChangeTelemetry: ToggleProps['onChange'] = useCallback(
    (checked, event) =>
      requestValidation()
        .then(() => dispatch(toggleTelemetry(checked)))
        .catch(() => {}),
    [dispatch, requestValidation]
  );

  return (
    <div>
      <Toggle
        size="lg"
        checked={isTelemetry}
        checkedChildren={intl.formatMessage({ id: 'general.ON' })}
        unCheckedChildren={intl.formatMessage({ id: 'general.OFF' })}
        onChange={onChangeTelemetry}
      />
    </div>
  );
});

export default React.memo(XRayGeneratorConfiguration);
